import produce from 'immer';
import { UPLOADED_IMAGE_LIST_REQUEST } from '../../constants/app/devImageUploadConstants';

const initialState = {

}

const devImageUploadReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case UPLOADED_IMAGE_LIST_REQUEST:
      break;

    default:
      break;
  }
});

export default devImageUploadReducer;
